module.exports = __webpack_public_path__ + "static/media/ic_temper_active.b2c048c8.png";